export default
{
  "cities": [{
    "isoCountry": "zw",
    "city": ["Bulawayo"]
  }]
}